import React, {useEffect} from 'react';

import {loadMetadata, selectMetadata} from 'entities/metadata';
import {selectContextRawData} from 'modules/context/context-selector';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import {Dashboard} from './dashboard';

export interface IWidgetSectionProps {
    entityName: string;
    parentEntityName: string;
}

export const DashboardContainer = ({entityName}: IWidgetSectionProps) => {
    const dispatch = useAppDispatch();
    const meta = useAppSelector(state => selectMetadata(entityName, EEntityType.DASHBOARD)(state));
    const context = useAppSelector(selectContextRawData);

    useEffect(() => {
        (async () => {
            if (!meta) {
                await dispatch(loadMetadata(entityName, EEntityType.DASHBOARD));
            }
        })();
    }, []);

    return meta && meta.fields ? (
        <Dashboard
            meta={meta}
            entityName={entityName}
            context={context}
        />
    ) : <></>;
};
